import React, { useState, useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { useLatest } from 'ahooks';
import service from '@/service';
import { selectCurrentServingOrder } from '@/store/service';
import { MassageType2Text } from '@/constant';
import { SlideModal, SuggestionsForFeedback } from '@/components';
import cx from './index.module.scss';

interface Props {}

enum BODY_PART_TEXT {
  Shoulder = '肩部',
  Abdomen = '腹部',
  Waist = '腰部',
  Back = '全背',
  All = '',
}

const SHOCKWAVE_TYPE_TEXT = {
  1: '德技',
  2: '艾兰',
};

const UserGuideTips: React.FC<Props> = props => {
  const currentServingOrder = useSelector(selectCurrentServingOrder);
  const latestOrder = useLatest(currentServingOrder);
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [userGuideImage, setUserGuideImage] = useState<string>(null);
  const [isShow, setIsShow] = useState<boolean>(false);

  const handleClose = async () => {
    setIsDrawerOpen(false);
    setTimeout(() => {
      setIsShow(false);
    }, 1000);
    await service.service.readUserGuide();
  };

  const getUserGuideInfo = useCallback(async () => {
    // 人工单项目（磁震波，射频，再生宝）是没有方案温馨提示弹窗的 1.10.0版本以上需要弹出方案温馨提示
    // if (
    //   latestOrder?.current?.onlyManual &&
    //   (latestOrder?.current?.productItems?.includes('Shockwave') ||
    //     latestOrder?.current?.productItems?.includes('HotStone') ||
    //     latestOrder?.current?.productItems?.includes('RadioFrequency'))
    // ) {
    //   return;
    // }
    const { data } = await service.service.getUserGuideInfo(latestOrder.current?.orderId);

    if (!data?.read && data?.image) {
      setIsShow(true);
      setUserGuideImage(data?.image);
      setTimeout(() => {
        setIsDrawerOpen(true);
      }, 100);
    }
  }, [latestOrder]);

  useEffect(() => {
    if (currentServingOrder?.orderId) {
      getUserGuideInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentServingOrder?.orderId]);

  return (
    isShow &&
    ReactDOM.createPortal(
      <SlideModal className={cx('modal-wrapper', { show: isDrawerOpen })} open={isDrawerOpen}>
        <div className={cx('modal-box')}>
          <div className={cx('head')}>
            <div className={cx('title')}>
              {currentServingOrder?.onlyManual ? (
                <span>{`${
                  currentServingOrder?.productItems?.[0] === 'RadioFrequency'
                    ? SHOCKWAVE_TYPE_TEXT[currentServingOrder?.shockwaveType]
                    : '人工'
                }${MassageType2Text[currentServingOrder?.productItems?.[0]]}`}</span>
              ) : (
                <span>{`${BODY_PART_TEXT[currentServingOrder?.bodyPart]}${
                  MassageType2Text[currentServingOrder?.productItems?.[0]]
                }`}</span>
              )}
              <span>理疗操作温馨提示</span>
            </div>
            <div className={cx('right')}>
              {isDrawerOpen && <SuggestionsForFeedback currentProcess="physical-therapy-notes" />}
              <div onClick={handleClose} className={cx('btn')}>
                我知道了
              </div>
            </div>
          </div>
          <div className={cx('content')}>
            <img src={userGuideImage} alt="user-guide-image" />
          </div>
        </div>
      </SlideModal>,
      document.body
    )
  );
};

export default UserGuideTips;
